// extracted by mini-css-extract-plugin
export default {"Logo":"CompanyLogo_Logo__Ou252","LogoText":"CompanyLogo_LogoText__aSwJ7"};